import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
import { OutputsPage } from "./OutputsPage";
export var Outputs = function () {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.ADMIN_LEGAL_DEPOSITS,
                    RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
                    RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
                ] },
                React.createElement(OutputsPage, null))); } })));
};
